import type { FaireProductEntity } from "../../entity_types/product";

export const p_wtpsxxe7cz: FaireProductEntity = {
  token: "p_wtpsxxe7cz",
  type: "product",
  name: "Glass Incense Holder",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/4199865bbb16118d59cfe9b34e0953bd27d4e4a5d5fd0460fec5dbab7a58c0c6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ebc2fd6c03e00aed74a483aeb2e8307576c0ba8eee41ccb72d50f3ad325a66d2.jpeg",
    "https://cdn.faire.com/fastly/3732ce2a3f406d71309d8124395d91a298e6e94f056cf22e941a7a34e507d7c2.jpeg",
    "https://cdn.faire.com/fastly/3f0aa1718062d12ef926d21e9b67f42bb7d99d0506a5d8346edab2595b45e85d.jpeg",
  ],
  priceDollars: 14.25,
  description:
    "An essential accessory for any incense lover, custom-made with amber-toned borosilicate glass and etched with P.F. Candle Co. branding. Pair with our Classic or HI-FI Incense Sticks to complete your atmosphere.\n\n\nHot tip: if you're finding that your incense isn't standing up straight and the ash is falling outside of the holder, try bending the end of the stick so that it holds firmer in the hole.\n\n",
  tags: [],
  msrpDollars: 23.94,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:04.816Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
